export default __webpack_public_path__ + "static/media/made-easy-phone-right.49c21502.webp";